import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, intro, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"} ${className}`}>
    {overline && (
      <Reveal>
        <span className="overline">{overline}</span>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2 className="mt-4 font-display text-3xl font-bold leading-[1.05] tracking-tight text-navy sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.1}>
        <p className="mt-5 text-base leading-relaxed text-steel sm:text-lg">{intro}</p>
      </Reveal>
    )}
  </div>
);

export const CtaBand = ({
  title = "Request a Customized Cleaning Plan",
  body = "",
  primary = { label: "Request a Customized Cleaning Plan", to: "/request-a-quote" },
  secondary = { label: "Schedule a Facility Walkthrough", to: "/contact" },
}) => (
  <section className="container-px mx-auto max-w-[1500px] py-20">
    <div className="relative overflow-hidden bg-navy px-8 py-16 sm:px-14 lg:px-20 lg:py-24 noise-overlay">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand-green/20 blur-3xl" />
      <div className="relative z-[2] grid gap-10 lg:grid-cols-[1.5fr_1fr] lg:items-end">
        <div>
          <Reveal>
            <span className="overline text-brand-green/90">Let's talk</span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              {title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            {body ? <p className="mt-5 max-w-xl text-base leading-relaxed text-white/60">{body}</p> : null}
          </Reveal>
        </div>
        <Reveal delay={0.15} className="flex flex-col gap-3 lg:items-end">
          <Link to={primary.to} data-testid="cta-band-primary" className="btn-primary w-full justify-center lg:w-auto">
            {primary.label}
            <ArrowUpRight size={16} />
          </Link>
          <Link
            to={secondary.to}
            data-testid="cta-band-secondary"
            className="inline-flex w-full items-center justify-center gap-2 border border-white/25 px-6 py-3.5 font-display text-sm font-semibold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-white hover:text-navy lg:w-auto"
          >
            {secondary.label}
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
